document.addEventListener('DOMContentLoaded', function () {
  var modal = document.getElementById('amane-surmesure-modal');
  var overlay = document.querySelector('[data-amane-sm-overlay]');
  var openers = document.querySelectorAll('[data-amane-sm-open]');
  var closers = document.querySelectorAll('[data-amane-sm-close]');
  if (!modal || !overlay) return;

  function openModal() {
    modal.classList.add('is-open');
    overlay.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
  }

  function closeModal() {
    modal.classList.remove('is-open');
    overlay.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
  }

  openers.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openModal();
    });
  });

  closers.forEach(function (btn) {
    btn.addEventListener('click', function () {
      closeModal();
    });
  });

  overlay.addEventListener('click', function () {
    closeModal();
  });

  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape') {
      closeModal();
    }
  });

  // Si le formulaire a été soumis (succès ou erreurs),
  // Shopify renvoie la page avec data-amane-sm-status présent.
  var formStatus = modal.querySelector('[data-amane-sm-status]');
  if (formStatus) {
    openModal();
  }
});